module.exports = __webpack_public_path__ + "img/icon-warning-ani.6cc15ca9.svg";